/**
 * Site header (blocks/header.liquid).
 * 1. Working hours pill: open or closed right now in Central time, with the six observed holidays
 *    (New Year's Day, Memorial Day, Independence Day, Labor Day, Thanksgiving, Christmas Day) and a 4 PM close on holiday eves.
 * 2. Hours popup and the phone search row open and close on tap.
 * 3. Only the menu row (desktop) or the logo row (phone) stays at the top when scrolling.
 * The header works without this file; the pill then reads "See hours".
 */
(function () {
  const header = document.querySelector('[data-header]');
  if (!header) return;

  /* ---------- Hours ---------- */
  const HOURS = { 0: null, 1: [10, 18], 2: [10, 18], 3: [10, 18], 4: [10, 18], 5: [10, 18], 6: [12, 16] };
  const EVE_CLOSE = 16;
  const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function centralNow() {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', hour12: false
    }).formatToParts(new Date());
    const get = (type) => Number(parts.find((p) => p.type === type).value);
    return new Date(get('year'), get('month') - 1, get('day'), get('hour') % 24, get('minute'));
  }

  function nthWeekday(year, month, weekday, n) {
    const first = new Date(year, month, 1);
    return new Date(year, month, 1 + ((weekday - first.getDay() + 7) % 7) + (n - 1) * 7);
  }
  function lastWeekday(year, month, weekday) {
    const last = new Date(year, month + 1, 0);
    return new Date(year, month, last.getDate() - ((last.getDay() - weekday + 7) % 7));
  }
  function holidays(year) {
    return [
      { name: "New Year's Day", date: new Date(year, 0, 1) },
      { name: 'Memorial Day', date: lastWeekday(year, 4, 1) },
      { name: 'Independence Day', date: new Date(year, 6, 4) },
      { name: 'Labor Day', date: nthWeekday(year, 8, 1, 1) },
      { name: 'Thanksgiving', date: nthWeekday(year, 10, 4, 4) },
      { name: 'Christmas Day', date: new Date(year, 11, 25) }
    ];
  }
  function sameDay(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  }
  function holidayOn(day) {
    return [...holidays(day.getFullYear()), ...holidays(day.getFullYear() + 1)].find((h) => sameDay(h.date, day)) || null;
  }
  function hoursOn(day) {
    if (holidayOn(day)) return null;
    const base = HOURS[day.getDay()];
    if (!base) return null;
    const tomorrow = new Date(day.getFullYear(), day.getMonth(), day.getDate() + 1);
    if (holidayOn(tomorrow)) return [base[0], Math.min(base[1], EVE_CLOSE)];
    return base;
  }
  function fmt(h) {
    const suffix = h >= 12 ? 'PM' : 'AM';
    const hr = h % 12 === 0 ? 12 : h % 12;
    return hr + ' ' + suffix;
  }

  function renderHours() {
    const wrap = header.querySelector('[data-hours]');
    if (!wrap) return;
    const now = centralNow();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const hours = hoursOn(today);
    const holiday = holidayOn(today);
    const hourNow = now.getHours() + now.getMinutes() / 60;
    const open = !!hours && hourNow >= hours[0] && hourNow < hours[1];

    const dot = wrap.querySelector('[data-hours-dot]');
    const status = wrap.querySelector('[data-hours-status]');
    dot.classList.toggle('is-open', open);
    dot.classList.toggle('is-closed', !open);
    if (holiday) status.textContent = 'Closed for ' + holiday.name;
    else if (open && hours[1] === EVE_CLOSE && HOURS[today.getDay()][1] !== EVE_CLOSE) status.textContent = 'Open, closes 4 PM';
    else status.textContent = open ? 'Open Now' : 'Closed';

    /* Popup rows show the next seven days' real hours, so a holiday this week reads correctly. */
    for (let i = 0; i < 7; i++) {
      const day = new Date(today.getFullYear(), today.getMonth(), today.getDate() + i);
      const row = wrap.querySelector('.hdr-hours__row[data-day="' + day.getDay() + '"]');
      if (!row) continue;
      const cells = row.querySelectorAll('span');
      const dh = hoursOn(day);
      const hol = holidayOn(day);
      cells[0].textContent = DAY_NAMES[day.getDay()];
      cells[1].textContent = hol ? 'Closed (' + hol.name + ')' : dh ? fmt(dh[0]) + ' – ' + fmt(dh[1]) : 'Closed';
      row.classList.toggle('is-holiday', !!hol);
      row.classList.toggle('is-today', i === 0 && !!dh);
      row.classList.toggle('is-today-closed', i === 0 && !dh);
    }
  }
  renderHours();
  setInterval(renderHours, 60000);

  /* ---------- Hours popup ---------- */
  const trigger = header.querySelector('.hdr-hours__trigger');
  const popup = header.querySelector('.hdr-hours__popup');
  function setPopup(open) {
    if (!trigger || !popup) return;
    trigger.setAttribute('aria-expanded', String(open));
    popup.hidden = !open;
  }
  if (trigger) {
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      setPopup(trigger.getAttribute('aria-expanded') !== 'true');
    });
    document.addEventListener('click', (e) => { if (!popup.contains(e.target)) setPopup(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setPopup(false); });
  }

  /* ---------- Phone search row ---------- */
  const searchToggle = header.querySelector('[data-search-toggle]');
  const searchRow = header.querySelector('#hdr-msearch');
  if (searchToggle && searchRow) {
    searchToggle.addEventListener('click', () => {
      const open = searchRow.hidden;
      searchRow.hidden = !open;
      searchToggle.setAttribute('aria-expanded', String(open));
      if (open) searchRow.querySelector('input[type="search"]').focus();
    });
  }

  /* ---------- Sticky: keep only the bottom row in view ---------- */
  const container = header.parentElement;
  const top = header.querySelector('.hdr-top');
  const main = header.querySelector('.hdr-main');
  const nav = header.querySelector('.hdr-nav');
  function setOffset() {
    const desktop = nav && getComputedStyle(nav).display !== 'none';
    let offset = top.offsetHeight;
    if (desktop) offset += main.offsetHeight;
    container.style.setProperty('--hdr-offset', '-' + offset + 'px');
  }
  setOffset();
  window.addEventListener('resize', setOffset);
  if ('ResizeObserver' in window) new ResizeObserver(setOffset).observe(header);
})();
